import React, { useCallback } from "react";
import { useAtomValue } from "jotai";
import { Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { achievementLevelAtom } from "atoms/Ltool/matrixAtoms";
import { powertrainAtom } from "atoms/powertrainAtom";
import { gearIdAtom } from "atoms/gearAtom";
import { buildMatrixExcelBlob } from "../utils/exportMatrixExcel";

const makeFileName = () => {
    const now = new Date();
    const pad = (v: number) => v.toString().padStart(2, "0");
    const timestamp = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`;
    return `achievement_matrix_${timestamp}.xlsx`;
};

export const DownloadMatrixCsvButton: React.FC = () => {
    const allMatrixData = useAtomValue(achievementLevelAtom);
    const powertrain = useAtomValue(powertrainAtom);
    const gearId = useAtomValue(gearIdAtom);
    const isHev = powertrain === "hev";
    const isReady = allMatrixData.status === "success" && (!isHev || Boolean(gearId));

    const handleDownload = useCallback(async () => {
        if (!isReady) return;
        const blob = await buildMatrixExcelBlob(allMatrixData.data, isHev);
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = makeFileName();
        link.click();
        URL.revokeObjectURL(url);
    }, [allMatrixData, isReady, isHev]);

    return (
        <Button
            variant="outlined"
            startIcon={<DownloadIcon />}
            onClick={handleDownload}
            disabled={!isReady}
            sx={{ ml: 2 }}
        >
            Excelダウンロード
        </Button>
    );
};
